import { Component, ElementRef, inject, Input, OnInit, SkipSelf, TemplateRef, ViewChild } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { FormGroup } from '@angular/forms';
import { AgreementForm } from '../../../shared-agreement.model';
import { AgreementComponent } from 'app/features/agreement/pages/agreement/agreement.component';
@UntilDestroy()
@Component({
    selector: 'app-agreement-details',
    templateUrl: './agreement-details.component.html',
    styleUrl: './agreement-details.component.scss'
})
export class AgreementDetailsComponent implements OnInit {
    @Input() public agreementForm: FormGroup<AgreementForm>;
    @Input() public showPotentialValidationMessages: boolean;

    @ViewChild('editModeFooterTemplate', { static: true })
    public readonly editModeFooterTemplate: TemplateRef<ElementRef>;

    @SkipSelf() private readonly agreementComponent = inject(AgreementComponent);

    public submitting: boolean;

    public get detailsForm() {
        return this.agreementForm.controls.details;
    }

    public get periodForm() {
        return this.agreementForm.controls.period;
    }

    public get reminderForm() {
        return this.agreementForm.controls.reminder;
    }

    public get paymentForm() {
        return this.agreementForm.controls.payment;
    }

    public get realEstateForm() {
        return this.agreementForm.controls.realEstate;
    }

    public get rentalForm() {
        return this.agreementForm.controls.rental;
    }

    public get inventoryForm() {
        return this.agreementForm.controls.inventory;
    }

    public get fileForm() {
        return this.agreementForm.controls.fileUpload;
    }

    public get f() {
        return this.agreementForm.controls;
    }

    public ngOnInit() {
        this.agreementComponent.setFooterTemplate(this.editModeFooterTemplate);
    }

    public cancel() {
        this.agreementComponent.cancel();
    }

    public save() {
        this.agreementComponent.save();
    }
}
